module.exports = __webpack_public_path__ + "media/images/logo-2x-70d726f8774f4ce51dcd34541bda0ca6.png";